import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'; 
import { Globals } from '../objects/Globals';
import { Summary, FilterOption } from '../objects/SummaryObject';
import { Observable, forkJoin, Subject } from 'rxjs';
import { catchError, map, tap, timeout } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { EnvService } from '../env.service';

@Injectable({
  providedIn: 'root'
})
export class SummaryService {
  private loginUrl: string;
  private serviceUrl: string;

  private enableSearch = new Subject<boolean>();
  enableSearchChanged$ = this.enableSearch.asObservable();

  private filter = new Subject<any>();
  filterChanged$ = this.filter.asObservable();
  
  private sort = new Subject<any>();
  sortChanged$ = this.sort.asObservable();

  private chartTable = new Subject<any>();
  chartTableChanged$ = this.chartTable.asObservable();

  private hasNewMessages = new Subject<boolean>();
  hasNewMessagesChanged$ = this.hasNewMessages.asObservable();

  private summaryUpdate = new Subject<boolean>();
  summaryUpdateChanged$ = this.summaryUpdate.asObservable();

  setEnableSearch(search: boolean){
    this.enableSearch.next(search);
  }

  setFilter(column: any){
    this.filter.next(column);
  }

  setSort(column: any){
    this.sort.next(column);
  }

  setChartTable(loading: boolean){
    this.chartTable.next(loading);
  }

  setHasNewMessages(loading: boolean){
    this.hasNewMessages.next(loading);
  }

  setSummaryUpdate(update: boolean){
    this.summaryUpdate.next(update);
  }
  
  createSummary(type:string, summaryName:string):Observable<string>{
    var path = this.loginUrl +"GetNewSummary/" + type + "/" + summaryName;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }  

  getNewSummaryFromDetail(detailCardId:string, groupId:string, noRelation: boolean):Observable<string>{
    var path = this.loginUrl +"GetNewSummaryFromDetail/" + detailCardId + "/" + groupId + "?noRelation=" + noRelation;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  getDataSetSummaryFromDetail(detailCardId:string, propertyId:string):Observable<string>{
    var path = this.loginUrl +"GetDataSetSummaryFromDetail/" + detailCardId + "/" + propertyId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }  

  getSummary(id:string):Observable<string>{
    var path = this.loginUrl +"GetSummaryCard/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };

    return this.http.get<string>(`${path}`, httpOptions).timeout(20000);
  }

  getSummaryFilterOptions(id:string):Observable<string>{
    var path = this.loginUrl +"GetSummaryCardFilterOptions/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getSummaryDropdownList(id:string, summaryItemId: string, propertyName:string){
    var path = this.loginUrl +"GetSummaryDropdownList/"+id+"/"+summaryItemId+"/"+propertyName;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getSummaryFilterOptionList(id:string, fieldName:string):Observable<string>{
    var path = this.loginUrl +"GetSummaryCardFilterOptionList/" + id + "/" + fieldName;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  changeFilter(id:string, filterChecked:FilterOption[]):Observable<string>{
    var path = this.loginUrl +"ChangeSummaryFilter/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, JSON.stringify(filterChecked) , httpOptions);
  }

  applyFilters(id:string){
    var path = this.loginUrl +"ApplySummaryFilter/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  getCurrentSort(id: string): Observable<string> {
      var path = this.loginUrl + "GetCurrentSort/" + id;
      var httpOptions = {
          headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
      };
      return this.http.get<string>(`${path}`, httpOptions);
  }

  getCurrentSearchKeyword(id: string): Observable<string> {
      var path = this.loginUrl + "GetCurrentSearchTerm/" + id;
      var httpOptions = {
          headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
      };
      return this.http.get<string>(`${path}`, httpOptions);
  }
  getSummarySortOptions(id:string):Observable<string>{
    var path = this.loginUrl +"GetSummaryCardSortOptions/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  createSummaryWithRelation(type:string, summaryName:string, relatedType:string, relatedId:string):Observable<string>{
    var path = this.loginUrl +"GetNewSummary/" + type + "/" + summaryName+"?relatedParentType="+relatedType+"&relatedParentId="+relatedId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  selectItem(id:string, selectedId:string):Observable<string>{
    var path = this.loginUrl +"SelectSummaryItem/" + id + "/" + selectedId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  selectItems(id:string, param:any):Observable<string>{
    var path = this.loginUrl +"SelectItems/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, param, httpOptions);
  }

  previousPage(id:string):Observable<string>{
    var path = this.loginUrl +"SummaryPreviousPage/" + id ;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  nextPage(id:string):Observable<string>{
    var path = this.loginUrl +"SummaryNextPage/" + id ;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  changePage(id:string, selectedPage: number):Observable<string>{
    var path = this.loginUrl +"ChangeSummaryPage/" + id + "/" + selectedPage;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  searchKeyword(id:string, keyword:string):Observable<string>{
    var path = this.loginUrl +"SearchSummaryByKeyword/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, keyword, httpOptions);
  }

  searchAndReturnSummary(id:string, keyword:string):Observable<string>{
    var path = this.loginUrl +"SearchSummaryByKeyword/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    
    return this.http.post<string>(`${path}`, keyword, httpOptions).switchMap(result => {
      var path = this.loginUrl +"GetSummaryCard/" + id;
      var httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
      };
      
      return this.http.get<string>(`${path}`, httpOptions).timeout(20000);
    });
  }

  clearKeyword(id:string):Observable<string>{
    var path = this.loginUrl +"ClearSummaryKeyword/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  changeSortType(id:string, sortType:string):Observable<string>{
    var path = this.loginUrl +"ChangeSummaryOrderType/" + id + "/" + sortType ;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  changeSortDirection(id:string, sortDirectionIsAscending:string):Observable<string>{
    var path = this.loginUrl +"ChangeSummaryOrderDirection/" + id + "/" + sortDirectionIsAscending ;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  changePageSize(id:string, selectedSize:string):Observable<string>{
    var path = this.loginUrl +"ChangeSummaryPagingSize/" + id + "/" + selectedSize ;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }
  
  downloadFile(attachmentId:string):Observable<Blob>{
    var path = this.loginUrl +"DownloadFile/"+attachmentId;
    var httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({ 'Content-Type': 'application/json','Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<Blob>(`${path}`, httpOptions);
  }

  getImageData(attachmentId:string):Observable<Blob>{
    var path = this.loginUrl +"DownloadFile/"+attachmentId;
    var httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<Blob>(`${path}`, httpOptions);
  }

  getAllImage(ids: string[]) {
    let getObs = [];
    for (let id of ids) {
      var path = this.loginUrl + "DownloadFile/" + id;
      var httpOptions = {
        responseType: 'blob' as 'json',
        headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
      };
      getObs.push(this.http.get<Blob>(`${path}`, httpOptions));
    }
    return forkJoin(getObs);
  }

  summaryItem(id:string, selectedId:string, param, actionName: string):Observable<string>{
    var path = this.loginUrl +"SummaryItemAction/" + id + "/" + selectedId + "/" + actionName;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, param, httpOptions);
  }

  summaryAction(id:string, param, actionName: string):Observable<string>{
    var path = this.loginUrl +"SummaryAction/" + id + "/" + actionName;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, param, httpOptions);
  }

  createSummaryPendingItems():Observable<string>{
    var path = this.serviceUrl +"CreatePendingItemsCard";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  selectSummaryPendingItems(id:string, type:string):Observable<string>{
    var path = this.serviceUrl +`SelectPendingItem/${id}/${type}`;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`,"", httpOptions);
  }

  getSummaryPendingItems(id:string):Observable<string>{
    var path = this.serviceUrl +"GetPendingItemsCard/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getSelectedId(id:string):Observable<string>{
    var path = this.loginUrl +"GetSummarySelectedId/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  checkIfSummaryHasUpdate(id:string):Observable<string>{
    var path = this.loginUrl +"CheckIfSummaryHasUpdate/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  CheckSummaryTableSort(id:string):Observable<string>{
    var path = this.loginUrl +"CheckSummaryTableSortingByColumn/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  ChangeSummaryTableSorting(id:string, columnName:string):Observable<string>{
    var path = this.loginUrl +"ChangeSummaryTableSortingByColumn/" + id + "/" + columnName ;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  AddAdvancedSummaryFilter(id:string, param):Observable<string>{
    var path = this.loginUrl +"AddAdvancedSummaryFilter/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, param, httpOptions);
  }

  RemoveAdvancedSummaryFilter(id:string, filterPropertyName:string):Observable<string>{
    var path = this.loginUrl +"RemoveAdvancedSummaryFilter/" + id + "/" + filterPropertyName;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  ClearSummaryFilter(id:string):Observable<string>{
    var path = this.loginUrl +"ClearSummaryFilter/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  ClearAdvancedSummaryFilter(id:string):Observable<string>{
    var path = this.loginUrl +"ClearAdvancedSummaryFilter/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  CheckAdvancedSummaryFilter(id:string, filterPropertyName:string):Observable<string>{
    var path = this.loginUrl +"CheckAdvancedSummaryFilter/" + id + "/" + filterPropertyName;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  FilterColumnByValue(id:string, columnName:string, search:string):Observable<string>{
    var path = this.loginUrl +"FilterColumnByValue/" + id + "/" + columnName;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, search, httpOptions);
  }

  GetFilterColumnValue(id:string, columnName:string):Observable<string>{
    var path = this.loginUrl +"GetFilterColumnValue/" + id + "/" + columnName;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  ClearColumnFilter(id:string):Observable<string>{
    var path = this.loginUrl +"ClearColumnFilter/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  UserSelectionInput(id:string, value:string):Observable<string>{
    var path = this.loginUrl +"UserSelectionInput/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, value, httpOptions);
  }

  changeSummaryLayout(id:string):Observable<string>{
    var path = this.loginUrl +"ChangeSummaryLayout/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  saveCurrentSummarySortLayout(id:string):Observable<string>{
    var path = this.loginUrl +"SaveCurrentSummarySortLayout/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  requestEmailSummary(id:string):Observable<string>{
    var path = this.loginUrl +"RequestEmailSummary/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  summaryFunction(id:string, action:string, data: any):Observable<string>{
    var path = this.loginUrl +"SummaryFunction/" + id + "/" + action;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, data, httpOptions);
  }

  getConfirmationMessage(id:string, selectedItemId: string, command: string):Observable<string>{
    var path = this.loginUrl +"GetConfirmationMessage/" + id + "/" + selectedItemId + "/" + command;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getSummaryFilterDropdownList(id:string, propertyName:string){
    var path = this.loginUrl +"GetSummaryFilterDropdownList/" + id + "/" + propertyName;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  checkItem(id:string, selectedItemId:string, body: any):Observable<string>{
    var path = this.loginUrl +"CheckItem/" + id + "/" + selectedItemId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, body, httpOptions);
  }

  uncheckItem(id:string, selectedItemId:string):Observable<string>{
    var path = this.loginUrl +"UncheckItem/" + id + "/" + selectedItemId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  changeRowValue(id:string, selectedItemId:string, body: any):Observable<string>{
    var path = this.loginUrl +"ChangeRowValue/" + id + "/" + selectedItemId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, body, httpOptions);
  }

  addNewRemark(id:string, body: any):Observable<string>{
    var path = this.loginUrl +"AddNewRemark/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, body, httpOptions);
  }

  getSummaryBreakdownFromSummary(selectedItem:string, docType:string, summaryName:string, docId: string):Observable<string>{
    var path = this.loginUrl +"GetSummaryBreakdownFromSummary/" + selectedItem + "/" + docType + "/" + summaryName + "?docId="+ docId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  getBasicSummary(docType:string, summaryName:string):Observable<string>{
    var path = this.loginUrl +"GetNewSummary/" + docType + "/" + summaryName;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  checkAllItems(id: string):Observable<string>{
    var path = this.loginUrl +"CheckAllItems/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  uncheckAllItems(id: string):Observable<string>{
    var path = this.loginUrl +"UncheckAllItems/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  updateSummaryColumnState(id: string, data: any):Observable<string>{
    var path = this.loginUrl +"UpdateSummaryColumnState/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, data, httpOptions);
  }

  getSummaryColumnState(id:string){
    var path = this.loginUrl +"GetSummaryColumnState/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getFileReport(id:string, reportId: string):Observable<Blob>{
    var path = this.loginUrl +"GetFileReport/" + id + "/" + reportId;
    var httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<Blob>(`${path}`, httpOptions);
  }

  actionOnAllItem(id:string, param):Observable<string>{
    var path = this.loginUrl +"SummaryAllItemAction/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, param, httpOptions);
  }

  constructor(private http:HttpClient, private globals:Globals, private env: EnvService) { 
    this.loginUrl = this.env.servicePath; this.serviceUrl = this.env.servicePath
  }
}
